/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */
import { apiSlice } from "../apiSlice";
import { API, API_SLICE_TAGS } from "../../../globals/globals";
import { FetchBaseQueryMeta } from "@reduxjs/toolkit/dist/query";
import { ILoginRequest, IMigrateSites, IMigration } from "./types";
import { IPaginatedData } from "../devices/types";
import { IArgs } from "../deviceConfig/types";
import { sanitizeQueryParams } from "../../helpers/helpers";

export const migrationApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMigration: builder.query<IPaginatedData<IMigration>, IArgs>({
      query: (args) => ({
        url: `${API.ENDPOINTS.MIGRATION.path}?${sanitizeQueryParams(args.filters)}`,
        method: "GET",
      }),
      providesTags: [API_SLICE_TAGS.MIGRATION],
    }),
    loginRequest: builder.mutation<IMigration[], ILoginRequest>({
      query: (payload: ILoginRequest) => ({
        url: `${API.ENDPOINTS.MIGRATION.path}/devices`,
        method: "POST",
        body: { ...payload },
      }),
      // transformResponse: (data: any, meta: FetchBaseQueryMeta) => {
      //   return { status: meta?.response?.status, data };
      // },
    }),
    migrateDevices: builder.mutation({
      query: (payload: IMigrateSites) => ({
        url: `${API.ENDPOINTS.MIGRATION.path}/migrate/${payload.siteGroupId} `,
        method: "POST",
        body: { loginRequest: payload.loginRequest, devices: payload.devices },
      }),
      transformResponse: (data: any, meta: FetchBaseQueryMeta) => {
        return { status: meta?.response?.status, ...data };
      },
    }),
  }),
});
export const { useGetMigrationQuery, useLoginRequestMutation, useMigrateDevicesMutation } = migrationApiSlice;
